import { render, staticRenderFns } from "./HomeTip.vue?vue&type=template&id=0c5bc020&scoped=true&"
import script from "./HomeTip.vue?vue&type=script&lang=js&"
export * from "./HomeTip.vue?vue&type=script&lang=js&"
import style0 from "./HomeTip.vue?vue&type=style&index=0&id=0c5bc020&prod&class=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5bc020",
  null
  
)

export default component.exports